<template>
  <div class="info-box-details">
    <div class="info-box-details-caption">Last user locations<br />per country in last 3 days</div>
    <div class="info-box-details-table">
      <table class="table table-borderless">
        <tbody>
          <tr repeat.for="countryUsersCount of model">
            <td style="text-align: left;"><i class="${ countryUsersCount.country.icon }"></i><span class="ml-2">${ countryUsersCount.country.name }</span></td>
            <td style="text-align: right;">${ countryUsersCount.usersCount }</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
